<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from '@/commons/FormElements/TextareaField.vue';

export default {
    components: {
        TextField,
        TextareaField,
    },
    name: 'RegisterStep1',
    data() {
        return {
            account_name: '',
            first_name: '',
            last_name: '',
            purpose: '',
            toggledViewPassword: false,
        };
    },
    computed: {
        formValid() {
            return (
                this.account_name &&
                this.first_name &&
                this.last_name &&
                this.purpose
            );
        },
    },
    methods: {
        onSubmit() {
            const { account_name, first_name, last_name, purpose } = this;
            this.$emit('submit', {
                account_name,
                first_name,
                last_name,
                purpose,
            });
        },
        setData(value) {
            this.account_name = value.account_name;
            this.first_name = value.first_name;
            this.last_name = value.last_name;
            this.purpose = value.purpose;
        },
    },
};
</script>

<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <form @submit.prevent="handleSubmit(onSubmit)">
            <TextField
                v-model="account_name"
                name="account_name"
                label="Account Name"
                rules="required"
            />
            <TextField
                v-model="first_name"
                name="first_name"
                label="Contact First Name"
                rules="required"
            />
            <TextField
                v-model="last_name"
                name="last_name"
                label="Contact Last Name"
                rules="required"
            />
            <TextareaField
                v-model="purpose"
                name="purpose"
                label="Fund Purpose"
                rules="required"
                rows="5"
            />
            <button
                class="btn-dialog btn-sm ok-btn w-100 mt-5"
                type="submit"
                :disabled="invalid"
            >
                NEXT
                <i class="fa fa-chevron-right ml-2" aria-hidden="true"></i>
            </button>
        </form>
    </ValidationObserver>
</template>
